export enum Genders {
    none,
    male,
    female,
    other
}